import React, { useState } from "react";
import SectionWrapper from "../../../components/SectionWrapper";
import SideImage from "./../../../assets/frame1.png";
import { Form, Input, message } from "antd";
import { Link, useHistory } from "react-router-dom";
import { Label } from "../../../styles";
import {
  ForgetPassword,
  FormWrapper,
  LoginWrapper,
  Navigator,
  Spacer,
} from "./styles";
import {
  signInWithPopup,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
} from "firebase/auth";
import Button from "../../../components/Button";
import { Checkbox } from "../../../components/Checkbox/style";
import { auth } from "../../../firebase";
import PaywallPopup from "../../../components/Paywall Popup/PaywallPopup";

const SectionContent = () => {
  return <></>;
};
const Index = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const onFinish = async (values) => {
    const { email, password } = values;
    setLoading(true);
    signInWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        // Signed in
        setLoading(false);
        history.push("/upload1");
        // ...
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage = error.message;
        message.error(errorMessage);
      });
  };
  const handleGoogleSignin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      signInWithPopup(auth, provider)
        .then((result) => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          history.push("/upload1");
        })
        .catch((error) => {
          // Handle Errors here.
          const errorMessage = error.message;
          message.error(errorMessage);
        });
    } catch (error) {
      message.error(error.message);
    }
  };
  const showModal = () => {
    setIsVisible(true);
  };
  const hideModal = () => {
    setIsVisible(false);
  };
  return (
    <LoginWrapper>
      <SectionWrapper
        style={{ cursor: "pointer" }}
        onClick={showModal}
        image={SideImage}
        SectionContent={SectionContent}
      >
        {isVisible && <PaywallPopup onClick={hideModal} />}
        <FormWrapper>
          <Form
            name="normal_login"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
          >
            <Button
              handleClick={handleGoogleSignin}
              className="google__btn"
              veriant="primary"
              size="medium"
              block
            >
              Log in with Google
            </Button>
            <Spacer>
              <p>or</p>
            </Spacer>
            <Label>E-mail*</Label>
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: false,
                },
              ]}
            >
              <Input className="input" style={{ height: 50 }} />
            </Form.Item>
            <Label>Password*</Label>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: false,
                },
              ]}
            >
              <Input.Password className="input" style={{ height: 50 }} />
            </Form.Item>
            <ForgetPassword>
              <Link to="/forget-password">Forget Password</Link>
            </ForgetPassword>
            <Button
              className="login__submit--btn"
              veriant="primary"
              size="medium"
              block
              type="submit"
              loading={loading}
            >
              Log in with Email
            </Button>
            <div className="remember">
              <Checkbox>Remember me!!</Checkbox>
            </div>
            <Navigator style={{ marginTop: 20 }}>
              New to Tube2Blog? <Link to="/signup">Sign up</Link>
            </Navigator>
          </Form>
        </FormWrapper>
      </SectionWrapper>
    </LoginWrapper>
  );
};

export default Index;
